import { Accessor, Component, createSignal, For, onMount } from "solid-js";
import { Img } from "../universal/image";
import { Blog } from "../../library/types";
import "./index.css";

type Props = {
    blogs: Accessor<Blog[]>;
}

export const RecentBlogPostsBar: Component<Props> = ({ blogs }) => {
    return (
        <div class="thumbnails">
            <For each={(blogs()?.slice(1)) ?? []}>
                {(blog) => (
                <div class="card">
                    <div class="image" style="background-color: #000; text-align: center;">
                        <a href={`/blog/index/${blog.Id}`}>
                            <Img
                                src={blog.BlogPostImages[0].URL}
                                alt={blog.Title}
                                height={150}
                                style="height: 150px; margin: 0 auto;"
                            />
                        </a>
                    </div>
                    <div style="padding: 3px;">
                        <div class="title">
                            <a href={`/blog/index/${blog.Id}`}>{blog.Title}</a>
                        </div>
                    </div>
                </div>
                )}
            </For>
        </div>
    );
}